<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">


      <vs-card>
      <vs-table multiple stripe v-model="selectedPayrolls" :max-items="paginate" pagination search :data="payrolls">
<template  slot="header">
    <vs-button @click="baixar" v-if="relatorio " class="ml-3"  color="success" iconPack="feather"
            icon="icon-download" target="_blank" :href="relatorio">Download</vs-button>
          <vs-button v-if="selectedPayrolls!=''" class="ml-3"  color="primary" iconPack="feather"
            icon="icon-printer" @click="getRelatorios">Imprimir</vs-button>
                  <select @change="getEmployees"  class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" v-validate="'excluded:1,2,3'"  v-model="paginate" name="not_in_field" data-vv-as="selectedPayrolls">
    <option class="vs__selected-options" value="5">5</option>
    <option class="vs__selected-options" value="10">10</option>
    <option class="vs__selected-options" value="15">20</option>
    <option class="vs__selected-options" value="50">50</option>
     <option class="vs__selected-options" value="100">100</option>
     <option class="vs__selected-options" value="500">500</option>
      <option class="vs__selected-options" value="1000">1000</option>
      <h4 class="ml-3">Total: {{total}}</h4>
  </select>
          </template>
    <template slot="thead">
      <vs-th sort-key="name">Nome</vs-th>
      <vs-th sort-key="surname">Apelido</vs-th>
       <vs-th sort-key="start_date">Data inicial</vs-th>
    <vs-th sort-key="end_date">Data de término</vs-th>
    <!-- <vs-th sort-key="status">Estado</vs-th> -->
    <vs-th></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].name">
          {{ data[indextr].name }}
        </vs-td>

        <vs-td :data="data[indextr].surname">
          {{ data[indextr].surname }}
        </vs-td>

       
  <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>
       <vs-td :data="data[indextr].end_date">
        {{ data[indextr].end_date }}
      </vs-td>

       
      <!-- <vs-td class="font-bold whitespace-no-wrap" >
            <vs-chip v-if="data[indextr].status=='0'">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-warning'"></div>
                        <span>Rascunho</span>
                    </vs-chip>
                     <vs-chip v-if="data[indextr].status=='1'">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                        <span>Pendente</span>
                    </vs-chip>
                     <vs-chip v-if="data[indextr].status=='2'">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                        <span>Aprovado</span>
                    </vs-chip>
                    <vs-chip v-if="data[indextr].status=='3'">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                        <span>Reprovado</span>
                    </vs-chip>
                    <vs-chip v-if="data[indextr].status=='4'">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                        <span>Cancelado</span>
                    </vs-chip>

                    
      </vs-td>
      -->
    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
        <vs-row>
                    <!-- <vs-button color="success" size="small" hover:text-danger   @click="popupOpenEdit(tr)">
Cancelar
                    </vs-button> -->
                    <vs-button  class="ml-2" color="success"  type="border" size="small" iconPack="feather"
            icon="icon-eye" :to="{
                      name: 'processar-salario-detalhes',
                      params: { processamentoId: data[indextr].payroll_id},
                    }" > </vs-button>
                    <vs-button :disabled="data[indextr].status=='2'" class="ml-2" color="danger"  type="border" size="small"          iconPack="feather"
            icon="icon-trash" @click="openConfirm(tr)"></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

      </vs-tr>
    </template>
    
  </vs-table>
   
  <div style="height: 50px;" id="payroll-loading" class="vs-con-loading__container"></div>
</vs-card>
      
    
   
  <div class="vx-col w-full sm:w-1/2 md:w-full mb-base">
                

                <vx-card title="Histórico de Aprovações">
                  <ul class="vx-timeline">
      <li  v-for="historico in historicos" :key="id">
          <div v-if="historico.status=='Reprovado por'" class="timeline-icon bg-warning">
              <feather-icon icon="AlertCircleIcon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div v-if="historico.status=='Aprovado por'" class="timeline-icon bg-success">
              <feather-icon icon="CheckCircleIcon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div v-if="historico.status=='Cancelado por'" class="timeline-icon bg-danger">
              <feather-icon icon="XCircleIcon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div v-if="historico.status=='Submetido por'" class="timeline-icon bg-primary">
              <feather-icon icon="ArrowUpIcon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div v-if="historico.status=='Criado por'" class="timeline-icon bg-dark">
              <feather-icon icon="FileTextIcon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info">
              <p class="font-semibold">{{ historico.status }} {{ historico.username }}</p>
              <span class="activity-desc">{{ historico.observation }}</span>
          </div>
          <small class="text-bold activity-e-time">Data: {{  historico.created_at.slice(0, 10)}} às {{  historico.created_at.slice(11, 16)}}</small>
      </li>
     
  </ul>
                </vx-card>
            </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import ProcessamentoList from './ProcessamentoList.vue'
import ProcessamentoAdd from './ProcessamentoAdd.vue'
import { PermissionsMixin } from '../../../../mixins/permissions'
import VxTimeline          from "@/components/timeline/VxTimeline.vue"
import http from '../../../../../http-common'


export default {
  mixins:[PermissionsMixin],
    components: {
     ProcessamentoList,
     ProcessamentoAdd,
    vSelect,
    VxTimeline
  },
  data() {
    return {
      observation:"",
  historicos:[],
  popupReprovar:false,
      checkBox1:false,
      status:"",
      folha:[],
      relatorioVer:"",
      Items:[],
      relatorio:"",
      down:false,
      amount:"",
      reason:"",
      type:"",
      selectedComponent:[],
      name:"",
      abbreviation:"",
      selected:[],
      components:[],
      employees:[],
     result:[],
     payrolls:[],
     selectedPayrolls:[],
paginate:"100",
fruitCollection: ["Horas Extras","Imposto sobre o Rendimento de Pessoas Singulares","Instituto Nacional de Segurança Social"],
folhas:[],
popupVer:false,
paperSize:"A3",
popupUpdateStatus:false,
popupGerar:false,
    }
    
  },

  mounted() {
    this.initialize();
  },

 
  methods: {
    async  initialize(){
      this.verifyPermissions();
      this.getFolha();
      this.getEmployees();
      this.getData();
      this.getColumns();
      
    },



 getEmployees() {
      //   this.$vs.loading({
      //   container: '#div-with-loading',
      //   scale: 1.0,
      //   type:'sound'
      // })
 
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       
      };
      
      
      http
        .get(`/salaries/payrolls-employees/${this.$route.params.folhaId}`, config)
        .then((result) => {
          // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.employees = result.data.Employees.reverse();
// alert("2")
        })
        .catch((error) => {
          error;
        //  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },
notificar() {
     this.result = this.selected.map(person => (person.employee_id ));
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
     
     
    http
        .get(`salaries/salary_paid_notification/${this.$route.params.folhaId}`,config)
        .then((success) => {
          success;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Notificações enviadas com sucesso",
            color: "success",
            position: "top-right",
          });
         
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==401 ){
            // this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao Marcar ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },


  saveProcessar() {
     this.result = this.selected.map(person => (person.employee_id ));
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        employee_id:this.result,
       
       payroll_entry_id:this.$route.params.folhaId


      };
     
    http
        .post("/salaries/payrolls", data, config)
        .then((success) => {
          success;
          this.selected=[],
          this.result=[],
        this.getEmployees();
        this.getData();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Processamento Feito com sucesso",
            color: "success",
            position: "top-right",
          });
         
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Sucesso",
            text: this.err,
            color: "danger",
            position: "top-right",
          })
          }else if(error.response.status==200 ){ 
             this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          } else{
this.$vs.loading.close();
          
          this.$vs.notify({
            title: "Erro",
            text: "falha ao Marcar ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
          }
          
        });
    
       
    },


    baixar(){
  this.selected="",
  this.relatorio="",
  this.fruitCollection=[]
},


getColumns() {
      
      //  this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/salaries/payrollSheet-columns", config)
        .then((result) => {
          //  this.$vs.loading.close()
          this.Items = result.data.Columns.reverse()
        
      //  this.Items= this.components.map(col => ({ name: col.name }));

        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },


    getData() {
        
      //     this.$vs.loading({
      //   container: '#payroll-loading',
      //   scale: 1.0,
      //   type:'sound'
      // })
 
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params:{type:1,
                year:this.year,
                month:this.month,
                payroll_entry_id:this.$route.params.folhaId,
                // page:50
          }
      };
      
      http
        .get("/salaries/payrolls", config)
        .then((result) => {
              // this.$vs.loading.close('#payroll-loading > .con-vs-loading')
          this.payrolls = result.data.Payrolls.reverse()

        })
        .catch((error) => {
          error;
                // this.$vs.loading.close('#payroll-loading > .con-vs-loading')
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

     saveMarcar() {
     
     this.result = this.selectedPayrolls.map(person => (person.employee_id ));
       
    },

    gerar() {
       this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
          params: {
                      
                         selectedColumns: this.fruitCollection,
                         paperSize: this.paperSize,
                    },
          
      };
      
      
      
      http
        .get(`salaries/print-one_payroll_Sheet/${this.$route.params.folhaId}`, config)
        .then((result) => {
         
          this.relatorio = result.data
          this.down=true,
          this.$vs.loading.close()
        })
        .catch((error) => {
           this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Informação",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
          })
        
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

 getRelatorios() {
       this.$vs.loading()
      this.result = this.selected.map(person => (person.employee_id ));
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
          params: {
                       
                         selectedColumns: this.fruitCollection,
                         paperSize: this.paperSize,
                         type:1,
                         payroll_entry:this.$route.params.folhaId,
                         employee_id:this.result
                    },
          
      };
      
      
      
      http
        .get("salaries/multi-receipts", config)
        .then((result) => {
         
          this.relatorio = result.data
          this.down=true,
          this.$vs.loading.close()
        })
        .catch((error) => {
           this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },


    openConfirm(dados) {
  this.dados=dados
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmação`,
                text: 'Tem certeza que deseja eliminar?' ,
                accept: this.remove
            })
        },

        async remove() {
            //  this.dados=dados
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      

     http
        .delete(`/salaries/payrolls/${this.dados.payroll_id}`,data, config)
        .then((success) => {
          success;
        
        this.getData(),
        this.getEmployees();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });

   
    },


    async popupOpenVer(){
  await this.getVisualizar()
         this.popupVer=true

          
        },

         getVisualizar() {
       this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
          params: {
                      
                        //  selectedColumns: this.Items,
                         paperSize: this.paperSize,
                    },
          
      };
      
      
      
      http
        .get(`salaries/print-one_payroll_Sheet/${this.$route.params.folhaId}`, config)
        .then((result) => {
         
          this.relatorioVer = result.data
          this.down=true,
          this.$vs.loading.close()
        })
        .catch((error) => {
           this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Informação",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
          })
        
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

    getFolha() {
      
      //  this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get(`/salaries/payroll-entry/${this.$route.params.folhaId}`, config)
        .then((result) => {
          //  this.$vs.loading.close()
          this.folha = result.data
          this.historicos = result.data.payrolls_steps.reverse()
        
      //  this.Items= this.components.map(col => ({ name: col.name }));

        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

  


    async updateStatus() {
        
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
    
      const data = {
          status:this.status,
          observation: this.observation
         
      };

     http
        .patch(`/salaries/approvals/${this.$route.params.folhaId}`, data, config)
        .then((success) => {
          success;
        this.popupReprovar=false
        this.abbreviation=""
        this.getFolha(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.abbreviation=""
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },


},

}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
